import { FC, useContext } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { context as StateContext } from '../context/state';
import _SideBar from '../component/compound/SideBar';

const SideBar: FC = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const state = useContext(StateContext);

  return state.authentication.signedInUser ? (
    <_SideBar
      onChangePage={(queryParams: string) => {
        navigate(`${pathname}?${queryParams}`, { replace: true });
      }}
    />
  ) : null;
};

export default SideBar;
